import { router } from '@/router';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import SvgSprite from 'vue-svg-sprite';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import VueGtm from 'vue-gtm';

// Tool tips
Vue.use(VTooltip, {
    autoHide: false,
    defaultContainer: 'body',
    defaultDelay: { show: 200, hide: 100 },
    defaultPlacement: 'top',
});

// Google Tag Manager
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TRACKING_ID,
    vueRouter: router,
});

// Recaptcha
Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true,
        explicitRenderParameters: {
            badge: 'bottomright',
        },
    },
});

// SVG Sprite
Vue.use(SvgSprite, {
    url: require('./svg/sprites.svg'),
    class: 'icon',
});